var _g, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadFont(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 129,
    viewBox: "0 0 200 129",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4",
    transform: "translate(50 1)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "\\u0444",
    transform: "translate(15 103)",
    fill: "#11d4fe",
    fontSize: 115.2,
    fontFamily: "TimesNewRomanPS-BoldItalicMT, Times New Roman",
    fontWeight: 700,
    fontStyle: "italic"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u0444")), /*#__PURE__*/React.createElement("text", {
    id: "f",
    transform: "translate(91 103)",
    fill: "#11d4fe",
    fontSize: 115.2,
    fontFamily: "TimesNewRomanPS-BoldItalicMT, Times New Roman",
    fontWeight: 700,
    fontStyle: "italic"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "f")), /*#__PURE__*/React.createElement("path", {
    id: "Line_7",
    "data-name": "Line 7",
    d: "M148.5.5H.5",
    transform: "translate(0 104)",
    fill: "none",
    stroke: "#11d4fe",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_7_Copy",
    "data-name": "Line 7 Copy",
    d: "M148.5.5H.5",
    transform: "translate(0 52)",
    fill: "none",
    stroke: "#11d4fe",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_7_Copy_2",
    "data-name": "Line 7 Copy 2",
    d: "M148.5.5H.5",
    transform: "translate(0 25)",
    fill: "none",
    stroke: "#11d4fe",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_7_Copy_3",
    "data-name": "Line 7 Copy 3",
    d: "M148.5.5H.5",
    transform: "translate(0 127)",
    fill: "none",
    stroke: "#11d4fe",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 36,
    cy: 36,
    r: 36,
    transform: "translate(1 1)",
    fill: "#fff",
    stroke: "#11d4fe",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Combined_Shape",
    "data-name": "Combined Shape",
    d: "M11,46V25H0L20.5,0,41,25H30V46Z",
    transform: "translate(17 13)",
    fill: "none",
    stroke: "#11d4fe",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadFont);
export default __webpack_public_path__ + "static/media/upload-font.9faa6d892998b1b5d7f973d78d1de336.svg";
export { ForwardRef as ReactComponent };